import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getBusinesses = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Business/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching businesses:", error);
    throw error;
  }
};

export const saveBusiness = async (business) => {
  const response = await axios.post(`${BASE_URL}/api/Business/save`, business, {
    headers: getAuthHeader(),
  });
  return response.data;
};
